<template>
  <div class="rb-title">
    <span>{{title}}</span>
  </div>
</template>

<script>
export default {
  name: 'v-title',
  props:{
    title: {
      type: [String, Number],
      default: ''
    },
  }
}
</script>

<style scoped lang="scss">
  .rb-title{
    margin:  30px 0;
   span{
     color: #000;
     font-weight: bold;
     font-size: 24px;
     &:before{
       content:'';
       border-left: 6px solid #076081;
       margin-right: 10px;
     }
   }
  }
</style>